// VoiceFabric page header — title block + domain selector + tab strip.
import React from 'react';
import { Zap, Globe } from 'lucide-react';

export const VoiceFabricHeader = ({ domains, domainId, onDomainChange, activeDomain }) => (
  <>
    <div className="flex items-start gap-4">
      <div className="p-3 rounded-xl bg-yellow-500/10">
        <Zap className="w-8 h-8 text-yellow-400" />
      </div>
      <div className="flex-1">
        <h1 className="text-2xl font-bold text-white">VoiceFabric Rule Builder</h1>
        <p className="text-white/40 text-sm mt-1">
          AI rules run against every graded call. When a rule matches, it logs the extraction or fires a webhook.
        </p>
      </div>
    </div>

    <div className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-xl px-4 py-3">
      <Globe className="w-4 h-4 text-teal-400" />
      <span className="text-white/40 text-xs uppercase tracking-widest">Domain</span>
      <select
        value={domainId}
        onChange={e => onDomainChange(e.target.value)}
        className="flex-1 bg-[#0A0F1C] border border-white/10 rounded-lg px-3 py-1.5 text-white text-sm focus:outline-none focus:border-teal-500/50"
        data-testid="vf-domain-select"
      >
        {domains.map(d => (
          <option key={d.id} value={d.id}>{d.company?.name || d.yabbit_domain}</option>
        ))}
      </select>
      {activeDomain && (
        <span className="text-white/30 text-xs font-mono">{activeDomain.yabbit_domain}</span>
      )}
    </div>
  </>
);

export const VoiceFabricTabs = ({ tabs, current, onChange }) => (
  <div className="flex gap-1 bg-white/5 p-1 rounded-xl w-fit">
    {tabs.map(t => (
      <button
        key={t.id}
        onClick={() => onChange(t.id)}
        data-testid={`vf-tab-${t.id}`}
        className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
          current === t.id ? 'bg-white/10 text-white' : 'text-white/40 hover:text-white/70'
        }`}
      >
        <t.icon className="w-3.5 h-3.5" />
        {t.label}
      </button>
    ))}
  </div>
);
